export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_DICTIONARY = 'SET_DICTIONARY'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_MANUFACTURERS = 'GET_MANUFACTURERS'
export const GET_MODELS = 'GET_MODELS'
export const GET_MACHINES = 'GET_MACHINES'
export const GET_MACHINE = 'GET_MACHINE'
export const GET_MACHINES_CAROUSEL = 'GET_MACHINES_CAROUSEL'
export const GET_QUOTATION_DATA = 'GET_QUOTATION_DATA'
export const GET_QUOTATION_DESTINATIONS = 'GET_QUOTATION_DESTINATIONS'